import {Pool} from "paravel"

export const pool = new Pool()
